import { render, staticRenderFns } from "./ChildrenInfo.vue?vue&type=template&id=6214001e&scoped=true&"
import script from "./ChildrenInfo.vue?vue&type=script&lang=ts&"
export * from "./ChildrenInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ChildrenInfo.vue?vue&type=style&index=0&id=6214001e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214001e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VIcon,VRow,VTooltip})
